module.exports = __webpack_public_path__ + "media/images/flags/1x1/irn-72fa1b0ff800a3ad11ff8bd3214f29fd.svg";